var render, staticRenderFns
import script from "./product_adjustment.vue?vue&type=script&lang=js&"
export * from "./product_adjustment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7dbbc989')) {
      api.createRecord('7dbbc989', component.options)
    } else {
      api.reload('7dbbc989', component.options)
    }
    
  }
}
component.options.__file = "found/views/mdm/views/product_adjustment/product_adjustment.vue"
export default component.exports